import React from 'react';

import { Heading, Projects } from '../../../components';



const ProjectSection = () => {
  return (

    <section>

      {/* Section heading */}
      <Heading title={'Our Projects'} subTitle={'Explore Our Work'} />

      {/* Projects Section */}
      <Projects />

    </section>

  );
}

export default ProjectSection;